import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * In-text contextual links to related services (SEO internal linking).
 * Uses <Link>, so the active language prefix (/en, /de) is preserved
 * automatically via the router basename.
 *
 * items: [{ to: "/depilation", labelKey: "servicesSidebar.depilation" }, ...]
 */
const RelatedServices = ({ items }) => {
  const { t } = useTranslation();
  if (!items || items.length === 0) return null;

  return (
    <div className="row">
      <div className="col-12">
        <div
          style={{
            margin: "10px 0 0",
            padding: "22px 26px",
            background: "#FAF7F2",
            border: "1px solid rgba(144,81,15,0.14)",
            borderRadius: "12px",
          }}
        >
          <p
            style={{
              margin: 0,
              fontFamily: "'Inter', sans-serif",
              fontSize: "15px",
              lineHeight: 1.7,
              color: "#5a4a3a",
            }}
          >
            {t("relatedServices.intro")}{" "}
            {items.map((it, i) => (
              <span key={it.to}>
                <Link
                  to={it.to}
                  style={{ color: "#90510F", fontWeight: 600, textDecoration: "underline" }}
                >
                  {t(it.labelKey)}
                </Link>
                {i < items.length - 1 ? " · " : "."}
              </span>
            ))}
          </p>
        </div>
      </div>
    </div>
  );
};

export default RelatedServices;
